import { ButtonTheme } from '@shared/components/button/enum';
import { ButtonStyle } from '@shared/components/button/model';

export const buttonStyle: { [key: string]: ButtonStyle } = {
  [ButtonTheme.WHITE]: {
    backgroundColor: 'WHITE',
    borderColor: 'BLACK',
    color: 'BLACK',
  },
  [ButtonTheme.FULL_WHITE]: {
    backgroundColor: 'WHITE',
    borderColor: 'WHITE',
    color: 'BLACK',
  },
  [ButtonTheme.TRANSPARENT_WHITE]: {
    backgroundColor: 'TRANSPARENT',
    borderColor: 'WHITE',
    color: 'WHITE',
  },
  [ButtonTheme.TRANSPARENT_BLACK]: {
    backgroundColor: 'TRANSPARENT',
    borderColor: 'BLACK',
    color: 'BLACK',
  },
  [ButtonTheme.BLUE]: {
    backgroundColor: 'BLUE',
    borderColor: 'BLUE',
    color: 'WHITE',
  },
  [ButtonTheme.RED]: {
    backgroundColor: 'RED',
    borderColor: 'RED',
    color: 'WHITE',
  },
  [ButtonTheme.ACTION]: {
    backgroundColor: 'ACTION',
    borderColor: 'ACTION',
    color: 'WHITE',
  },
};
